import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
const DesktopBodyScrollLock = t0 => {
  const $ = _c(8);
  const {
    children,
    className: t1,
    enabled: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const enabled = t2 === undefined ? true : t2;
  const scrollRootRef = useRef();
  let t3;
  let t4;
  if ($[0] !== enabled) {
    t3 = () => {
      if (scrollRootRef.current) {
        if (enabled) {
          disableBodyScroll(scrollRootRef.current);
        } else {
          enableBodyScroll(scrollRootRef.current);
        }
      }
    };
    t4 = [enabled];
    $[0] = enabled;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const scrollElement = scrollRootRef.current;
      return () => {
        if (scrollElement) {
          enableBodyScroll(scrollElement);
        }
      };
    };
    t6 = [];
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  useEffect(t5, t6);
  const t7 = `${className} DesktopBodyScrollLock`;
  let t8;
  if ($[5] !== children || $[6] !== t7) {
    t8 = <div className={t7} ref={scrollRootRef}>{children}</div>;
    $[5] = children;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  return t8;
};
DesktopBodyScrollLock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  enabled: PropTypes.bool
};
export default DesktopBodyScrollLock;